import {Injectable} from "@angular/core";
import {deleteToken, getToken, Messaging, onMessage} from "@angular/fire/messaging";
import {Observable, tap} from "rxjs";
import {gql, GqlService} from '@shared/services/gql.service';
import {
  MutationNotifyChannelUpdateArgs,
  MutationSaveFcmTokenArgs,
  NotifyChannelConnection,
  NotifyChannelFcmDevicePlatform,
  NotifyChannelWhereInput,
  QueryNotifyChannelQueryArgs,
  UpdateNotifyChannelInput
} from '@graphql/mesh-generated';
import {environment} from '../../../environments/environment';
import {StorageService} from '@shared/services/storage.service';

@Injectable({
  providedIn: "root",
})
export class FcmService {
  enabled: boolean = false;
  message$: Observable<any>;

  constructor(private msg: Messaging,
              private gqlService: GqlService,
              private storage: StorageService) {
    this.enabled = this.storage.getItem('fcm_enabled') === 'yes';
    this.message$ = new Observable((sub) => onMessage(this.msg, (msg) =>
      sub.next(msg))).pipe(
      tap((msg) => {
        this.gqlService.messageService.add({
          severity: 'info',
          summary: 'Alert',
          life: 10000,
          detail: msg.notification.body
        });
      })
    );
    this.toggleNotification(false);
  }


  testNotification(): void {
    this.gqlService.query<{}>(gql`query Query($platformUniqueId: String!) {
      SendFcmTestNotification(platformUniqueId: $platformUniqueId)
    }`, {
      platformUniqueId: this.storage.getOrStoreItem('platformUniqueId', this.storage.generateUUID),
    }).then(() => {
      this.gqlService.success('Test Notification Requested');
    })
  }

  toggleNotification(toast = true) {
    console.info('Toggle Notification', this.enabled);
    if (this.enabled) {
      Notification.requestPermission().then(
        (notificationPermissions: NotificationPermission) => {
          if (notificationPermissions === "granted") {
            console.info("Push notification Granted");
          }
          if (notificationPermissions === "denied") {
            this.enabled = false;
            if (toast) {
              this.gqlService.error(undefined, "Push notification permission denied");
            }
            console.error("Push notification Denied");
          }
        });

      navigator.serviceWorker
        .register("/assets/firebase-messaging-sw.js")
        .then((serviceWorkerRegistration) => {

          getToken(this.msg, {
            serviceWorkerRegistration: serviceWorkerRegistration,
            // This is a good place to then store it on your database for each user
          }).then(token => {
            this.saveTokenOnServer(token, toast);
          });
        }).catch((error) => {
        console.error("Service worker registration failed: ", error);
        this.enabled = false;
      });
    } else {
      // this.deleteToken(toast);
    }

  }

  saveTokenOnServer(token: string, toast = true) {

    this.gqlService.mutate<{ SaveFcmToken: boolean }>(gql`
        mutation SaveFcmToken($platformKind: NotifyChannelFcmDevicePlatform!, $fcmToken: String!, $fcmSenderId: String!, $platformUniqueId: String!, $platformFriendlyName: String!) {
          SaveFcmToken(platformKind: $platformKind, fcmToken: $fcmToken, fcmSenderId: $fcmSenderId, platformUniqueId: $platformUniqueId, platformFriendlyName: $platformFriendlyName)
        }
      `, {
        platformKind: NotifyChannelFcmDevicePlatform.Web,
        fcmToken: token,
        fcmSenderId: environment.firebaseConfig.messagingSenderId,
        platformUniqueId: this.storage.getOrStoreItem('platformUniqueId', this.storage.generateUUID),
        platformFriendlyName: this.storage.getOrStoreItem('platformFriendlyName', this.storage.generatePlatformFriendlyName),
      } as MutationSaveFcmTokenArgs,
      toast ? 'Failed to enable Push Notifications' : null,
      toast ? 'Push Notifications enabled successfully' : null,
    ).then((result) => {
      if (!result.SaveFcmToken && toast) {
        this.gqlService.error(undefined, 'Failed to enable Push Notifications');
        this.enabled = false;
      }
      this.storage.setItem('fcm_enabled', 'yes');
    }).catch(e => {
      console.error(e);
      this.enabled = false;
    });
  }


  deleteToken(toast = true) {
    deleteToken(this.msg).then();
    this.storage.removeItem('fcm_enabled');
    this.gqlService.query<{
      NotifyChannelQuery: NotifyChannelConnection
    }>(gql`
      query NotifyChannelQuery($where: NotifyChannelWhereInput) {
        NotifyChannelQuery(where: $where) {
          edges {
            node {
              id
            }
          }
        }
      }
    `, {
      where: {
        fcmDevicePlatform: NotifyChannelFcmDevicePlatform.Web,
        loggedInDeviceID: this.storage.getOrStoreItem('platformUniqueId', this.storage.generateUUID),
      } as NotifyChannelWhereInput
    } as QueryNotifyChannelQueryArgs).then((result) => {
      if (result.NotifyChannelQuery.edges.length > 0) {
        result.NotifyChannelQuery.edges.forEach(edge => {
          this.gqlService.mutate(gql`
            mutation NotifyChannelUpdate($id: ID!, $input: UpdateNotifyChannelInput!) {
              NotifyChannelUpdate(id: $id, input: $input) {
                id
              }
            }
          `, {
            id: edge.node.id,
            input: {
              enabled: false,
            } as UpdateNotifyChannelInput,
            } as MutationNotifyChannelUpdateArgs,
            toast ? 'Error Disabling notifications on server' : null,
            toast ? 'Push Notifications disabled successfully' : null).then(() => {
          });

        });

      }
    }).catch(e => console.error(e));
  }
}
